<script setup lang="ts">
/**
 * Bigote de Barberman, recreado del logotipo original en el color de la marca.
 *
 * Se dibuja UNA mitad y se refleja: la simetría sale exacta y cambiar la forma
 * es tocar una sola curva. Las dos mitades se juntan en el centro formando la
 * hendidura, que es lo que lo hace leerse como bigote y no como una mancha.
 *
 * "Barberman" se escribe SIEMPRE en alfabeto latino, también dentro de frases
 * en árabe: no se translitera ni se traduce.
 */
withDefaults(defineProps<{
  size?: number
  inverted?: boolean
  stacked?: boolean
  symbolOnly?: boolean
}>(), {
  size: 26,
  inverted: false,
  stacked: false,
  symbolOnly: false,
})

const HALF = 'M120 19C125 7 133 3 143 3.4C158 4 176 8 190 17C199 18 207 18.6 212.5 19.6C215 20.2 213 24.6 206 28C197 33.6 191 45 180 53C169 61 156 64.6 144 62.8C130 60.8 121.5 53 120 43Z'
</script>

<template>
  <span class="inline-flex items-center" :class="stacked ? 'flex-col gap-2' : 'gap-2.5'">
    <svg
      :width="size * 1.85"
      :height="size * 0.64"
      viewBox="22 0 196 68"
      aria-hidden="true"
      class="shrink-0"
      :fill="inverted ? '#FAF6EF' : 'var(--color-terracotta)'"
    >
      <path :d="HALF" />
      <path :d="HALF" transform="translate(240,0) scale(-1,1)" />
    </svg>

    <span
      v-if="!symbolOnly"
      class="font-display font-extrabold leading-none"
      :class="[
        inverted ? 'text-app' : 'text-ink',
        stacked ? 'tracking-[0.16em] uppercase' : 'tracking-tight',
      ]"
      :style="{ fontSize: `${size * (stacked ? 0.62 : 0.8)}px` }"
    >Barberman</span>
  </span>
</template>
